const Auxx = (props) => props.children;

export default Auxx;